//own imports
import ButtonSignUp from "../../common/buttons-sign-up/ButtonSignUp";
import ButtonSignIn from "../../common/buttons-sign-in/ButtonSignIn";

const HomeNotLoggedIn = () => {

    return (
        <div className="container-btn">
            <div className="btn-sign-in">
                <ButtonSignIn />
            </div>
            <div className="btn-sign-up">
                <ButtonSignUp />
            </div>
        </div>
    );
};

export default HomeNotLoggedIn;